import _styled87 from "../web_modules/styled-components.js";
import _styled86 from "../web_modules/styled-components.js";
import _styled85 from "../web_modules/styled-components.js";
import _styled84 from "../web_modules/styled-components.js";
import _styled83 from "../web_modules/styled-components.js";
import _styled82 from "../web_modules/styled-components.js";
import _styled81 from "../web_modules/styled-components.js";
import _styled80 from "../web_modules/styled-components.js";
import _styled79 from "../web_modules/styled-components.js";
import _styled78 from "../web_modules/styled-components.js";
import _styled77 from "../web_modules/styled-components.js";
import _styled76 from "../web_modules/styled-components.js";
import _styled75 from "../web_modules/styled-components.js";
import _styled74 from "../web_modules/styled-components.js";
import _styled73 from "../web_modules/styled-components.js";
import _styled72 from "../web_modules/styled-components.js";
import _styled71 from "../web_modules/styled-components.js";
import _styled70 from "../web_modules/styled-components.js";
import _styled69 from "../web_modules/styled-components.js";
import _styled68 from "../web_modules/styled-components.js";
import _styled67 from "../web_modules/styled-components.js";
import _styled66 from "../web_modules/styled-components.js";
import _styled65 from "../web_modules/styled-components.js";
import _styled64 from "../web_modules/styled-components.js";
import _styled63 from "../web_modules/styled-components.js";
import _styled62 from "../web_modules/styled-components.js";
import _styled61 from "../web_modules/styled-components.js";
import _styled60 from "../web_modules/styled-components.js";
import _styled59 from "../web_modules/styled-components.js";
import _styled58 from "../web_modules/styled-components.js";
import _styled57 from "../web_modules/styled-components.js";
import _styled56 from "../web_modules/styled-components.js";
import _styled55 from "../web_modules/styled-components.js";
import _styled54 from "../web_modules/styled-components.js";
import _styled53 from "../web_modules/styled-components.js";
import _styled52 from "../web_modules/styled-components.js";
import _styled51 from "../web_modules/styled-components.js";
import _styled50 from "../web_modules/styled-components.js";
import _styled49 from "../web_modules/styled-components.js";
import _styled48 from "../web_modules/styled-components.js";
import _styled47 from "../web_modules/styled-components.js";
import _styled46 from "../web_modules/styled-components.js";
import _styled45 from "../web_modules/styled-components.js";
import _styled44 from "../web_modules/styled-components.js";
import _styled43 from "../web_modules/styled-components.js";
import _styled42 from "../web_modules/styled-components.js";
import _styled41 from "../web_modules/styled-components.js";
import _styled40 from "../web_modules/styled-components.js";
import _styled39 from "../web_modules/styled-components.js";
import _styled38 from "../web_modules/styled-components.js";
import _styled37 from "../web_modules/styled-components.js";
import _styled36 from "../web_modules/styled-components.js";
import _styled35 from "../web_modules/styled-components.js";
import _styled34 from "../web_modules/styled-components.js";
import _styled33 from "../web_modules/styled-components.js";
import _styled32 from "../web_modules/styled-components.js";
import _styled31 from "../web_modules/styled-components.js";
import _styled30 from "../web_modules/styled-components.js";
import _styled29 from "../web_modules/styled-components.js";
import _styled28 from "../web_modules/styled-components.js";
import _styled27 from "../web_modules/styled-components.js";
import _styled26 from "../web_modules/styled-components.js";
import _styled25 from "../web_modules/styled-components.js";
import _styled24 from "../web_modules/styled-components.js";
import _styled23 from "../web_modules/styled-components.js";
import _styled22 from "../web_modules/styled-components.js";
import _styled21 from "../web_modules/styled-components.js";
import _styled20 from "../web_modules/styled-components.js";
import _styled19 from "../web_modules/styled-components.js";
import _styled18 from "../web_modules/styled-components.js";
import _styled17 from "../web_modules/styled-components.js";
import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";
import React from "../web_modules/react.js";
import { useRouteMatch, useParams, useHistory, useLocation } from "../web_modules/react-router-dom.js";
import VisuallyHidden from "../web_modules/@reach/visually-hidden.js"; // @ts-expect-error: TODO: Type this

import serialize from "../web_modules/for-cerial.js";
import "../web_modules/@reach/dialog/styles.css";
import { LanguageSelector, LoadingButton, Spinner, formatDate, formatDateTimeRange, makeDate } from "../web_modules/@ticketbutler/toolbox.js";
import "../web_modules/@ticketbutler/toolbox/dist/style.css";
import "../web_modules/@reach/menu-button/styles.css";
import ContentLoader from "../web_modules/react-content-loader.js";
import { useAsyncStatus, AsyncStates } from "../web_modules/use-async-status.js";
import { Helmet } from "../web_modules/react-helmet.js";
import { Seating } from "./seating.js";
import { WaitingList } from "./waiting_list.js";
import ticketbutlerFavicon from "./assets/ticketbutler_favicon.png";
import freeArrow from "./assets/icons/arrow.png";
import locationIcon from "./assets/icons/location_big.svg";
import calendarIcon from "./assets/icons/calendar_big.svg";
import { useLanguage, API_HOST, makeTbRequestHeaders, styles, getThemedButton, buttonCheckMark, RegistrationDialog, isShowSeatingMap, makeSearchParamString, cancelOrder } from "./app.js";
import { CheckoutContext, CheckoutDialog, Checkout, CHECKOUT_ROUTE, useExistingReservationInParam } from "./checkout.js";
import "./index.css";
import Select from "../web_modules/react-select.js";
import { PaymentIcons, isIframe, urlParams, getSearchParams, DescriptiveTextLabel, useIframeTypes, useScrollToError } from "./shared.js";
import { useTranslation } from "../web_modules/react-i18next.js";
const INITIAL_PATHNAME = window.location.pathname;
const MAX_CONTENT_WIDTH = isIframe ? 1200 : 1360;
const eventDetailHeading = {
  fontWeight: "bold",
  textTransform: "uppercase",
  color: "#333",
  fontSize: 14
}; // https://stackoverflow.com/a/5354536/4662825

function isInViewport(elm, threshold, mode) {
  threshold = threshold || 0;
  mode = mode || "visible";
  const rect = elm.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  const above = rect.bottom - threshold < 0;
  const below = rect.top - viewHeight + threshold >= 0;
  return mode === "above" ? above : mode === "below" ? below : !above && !below;
}

const isIOS = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
navigator.userAgent.includes("Mac") && "ontouchend" in document;

var _StyledSpan = _styled("span").withConfig({
  displayName: "event_page___StyledSpan",
  componentId: "sc-16syhiy-0"
})(["", ""], p => p._css);

var _StyledDiv = _styled("div").withConfig({
  displayName: "event_page___StyledDiv",
  componentId: "sc-16syhiy-1"
})({
  "@media (max-width: 1000px)": {
    margin: 10
  }
});

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv2",
  componentId: "sc-16syhiy-2"
})({
  display: "flex",
  alignItems: "center",
  marginBottom: "15px"
});

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv3",
  componentId: "sc-16syhiy-3"
})({
  textAlign: "center",
  marginRight: 10
});

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv4",
  componentId: "sc-16syhiy-4"
})({
  display: "flex",
  flexDirection: "column"
});

var _StyledSpan2 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan2",
  componentId: "sc-16syhiy-5"
})(["", ""], p => p._css2);

var _StyledDiv5 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv5",
  componentId: "sc-16syhiy-6"
})({
  display: "flex",
  alignItems: "center",
  marginBottom: "15px"
});

var _StyledDiv6 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv6",
  componentId: "sc-16syhiy-7"
})({
  width: "22px",
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  marginRight: 10
});

var _StyledDiv7 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv7",
  componentId: "sc-16syhiy-8"
})({
  display: "flex",
  flexDirection: "column"
});

var _StyledSpan3 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan3",
  componentId: "sc-16syhiy-9"
})(["", ""], p => p._css3);

var _StyledSpan4 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan4",
  componentId: "sc-16syhiy-10"
})(["", ""], p => p._css4);

var _StyledSpan5 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan5",
  componentId: "sc-16syhiy-11"
})(["", ""], p => p._css5);

var _StyledSpan6 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan6",
  componentId: "sc-16syhiy-12"
})(["", ""], p => p._css6);

var _StyledDiv8 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv8",
  componentId: "sc-16syhiy-13"
})({
  marginTop: 20,
  marginLeft: 10,
  display: "flex"
});

var _StyledDiv9 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv9",
  componentId: "sc-16syhiy-14"
})(["", ""], p => p._css7);

var _StyledP = _styled("p").withConfig({
  displayName: "event_page___StyledP",
  componentId: "sc-16syhiy-15"
})({
  textAlign: "center"
});

var _StyledDiv10 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv10",
  componentId: "sc-16syhiy-16"
})(["", ""], p => p._css8);

var _StyledDiv11 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv11",
  componentId: "sc-16syhiy-17"
})(["", ""], p => p._css9);

var _StyledDiv12 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv12",
  componentId: "sc-16syhiy-18"
})({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 0",
  [`@media(max-width: ${MAX_CONTENT_WIDTH + 20}px)`]: {
    padding: 10
  }
});

var _StyledSpan7 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan7",
  componentId: "sc-16syhiy-19"
})({
  userSelect: "none",
  fontSize: 52
});

var _StyledDiv13 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv13",
  componentId: "sc-16syhiy-20"
})(p => ({
  display: "flex",
  flexWrap: "wrap",
  width: p._css10,
  maxWidth: p._css11,
  justifyContent: p._css12,
  margin: "0 auto",
  alignItems: "flex-start",
  padding: "20px 0",
  "@media (max-width: 620px)": {
    padding: 0
  },
  [`@media (max-width: 1000px)`]: {
    flexDirection: "column",
    alignItems: "center"
  }
}));

var _StyledDiv14 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv14",
  componentId: "sc-16syhiy-21"
})({
  marginRight: 20,
  alignSelf: "flex-start"
});

var _StyledDiv15 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv15",
  componentId: "sc-16syhiy-22"
})({
  flex: 1,
  width: "100%",
  maxWidth: 700
});

var _StyledImg = _styled("img").withConfig({
  displayName: "event_page___StyledImg",
  componentId: "sc-16syhiy-23"
})({
  width: "100%",
  maxWidth: "100%",
  height: "auto",
  maxHeight: 510,
  display: "block",
  margin: "0 auto",
  borderRadius: 5,
  objectFit: "contain",
  [`@media (max-width: ${MAX_CONTENT_WIDTH}px)`]: {
    maxHeight: 260,
    borderRadius: 0
  }
});

var _StyledDiv16 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv16",
  componentId: "sc-16syhiy-24"
})(p => ({
  [`@media (max-width: ${MAX_CONTENT_WIDTH + 40}px)`]: {
    margin: "0 20px"
  },
  "@media(max-width: 1000px)": {
    borderTop: p._css13
  }
}));

var _StyledDiv17 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv17",
  componentId: "sc-16syhiy-25"
})(p => ({
  width: "100%",
  margin: p._css14,
  fontSize: 14,
  overflow: "auto",
  lineHeight: 1.8,
  "p img": {
    width: "100%",
    height: "auto"
  }
}));

var _StyledForm = _styled("form").withConfig({
  displayName: "event_page___StyledForm",
  componentId: "sc-16syhiy-26"
})(p => ({
  width: "100%",
  maxWidth: p._css15,
  backgroundColor: "white",
  boxShadow: "2px 2px 8px 0 #D4D9DF",
  "@media (max-width: 1000px)": {
    boxShadow: "none",
    maxWidth: 760
  }
}));

var _StyledDiv18 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv18",
  componentId: "sc-16syhiy-27"
})({
  padding: "15px 28px",
  display: "flex",
  flexDirection: "column",
  "@media (max-width: 1000px)": {
    padding: "10px 15px"
  }
});

var _StyledDiv19 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv19",
  componentId: "sc-16syhiy-28"
})({
  marginBottom: 20,
  marginLeft: 10,
  width: "max-content"
});

var _StyledDiv20 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv20",
  componentId: "sc-16syhiy-29"
})({
  minHeight: 80,
  padding: "5px 0 10px",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  alignItems: "center",
  borderBottom: "1px solid #eee",
  "@media (max-width: 500px)": {
    flexDirection: "column",
    alignItems: "flex-end"
  }
});

var _StyledDiv21 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv21",
  componentId: "sc-16syhiy-30"
})({
  flex: 1,
  minWidth: 140,
  "@media (max-width: 500px)": {
    minWidth: "auto",
    width: "auto",
    marginRight: "auto"
  }
});

var _StyledP2 = _styled("p").withConfig({
  displayName: "event_page___StyledP2",
  componentId: "sc-16syhiy-31"
})(["", ""], p => p._css16);

var _StyledP3 = _styled("p").withConfig({
  displayName: "event_page___StyledP3",
  componentId: "sc-16syhiy-32"
})(["", ""], p => p._css17);

var _StyledP4 = _styled("p").withConfig({
  displayName: "event_page___StyledP4",
  componentId: "sc-16syhiy-33"
})(["", ""], p => p._css18);

var _StyledDiv22 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv22",
  componentId: "sc-16syhiy-34"
})({
  marginBottom: 20,
  width: "max-content"
});

var _StyledDiv23 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv23",
  componentId: "sc-16syhiy-35"
})(p => ({
  display: "flex",
  flexDirection: p._css19,
  flexWrap: "wrap",
  alignItems: p._css20,
  padding: 5
}));

var _StyledDiv24 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv24",
  componentId: "sc-16syhiy-36"
})(p => ({
  marginRight: p._css21
}));

var _StyledSpan8 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan8",
  componentId: "sc-16syhiy-37"
})(["", ""], p => p._css22);

var _StyledSpan9 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan9",
  componentId: "sc-16syhiy-38"
})(p => ({
  fontWeight: "bold",
  fontSize: "14px",
  paddingRight: p._css23
}));

var _StyledSpan10 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan10",
  componentId: "sc-16syhiy-39"
})({
  fontWeight: "bold",
  fontSize: "14px"
});

var _StyledSpan11 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan11",
  componentId: "sc-16syhiy-40"
})(p => ({
  fontSize: 12,
  paddingRight: p._css24
}));

var _StyledDiv25 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv25",
  componentId: "sc-16syhiy-41"
})({
  fontSize: 12,
  textAlign: "center",
  paddingTop: 5,
  marginBottom: "-17px"
});

var _StyledDiv26 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv26",
  componentId: "sc-16syhiy-42"
})({
  borderBottom: "1px solid #eee"
});

var _StyledDiv27 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv27",
  componentId: "sc-16syhiy-43"
})({
  minHeight: 80,
  padding: "5px 0 10px",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  alignItems: "center",
  "@media (max-width: 500px)": {
    flexDirection: "column",
    alignItems: "flex-end"
  }
});

var _StyledDiv28 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv28",
  componentId: "sc-16syhiy-44"
})({
  flex: 1,
  minWidth: 140,
  "@media (max-width: 500px)": {
    minWidth: "auto",
    width: "auto",
    marginRight: "auto"
  }
});

var _StyledP5 = _styled("p").withConfig({
  displayName: "event_page___StyledP5",
  componentId: "sc-16syhiy-45"
})(["", ""], p => p._css25);

var _StyledP6 = _styled("p").withConfig({
  displayName: "event_page___StyledP6",
  componentId: "sc-16syhiy-46"
})(["", ""], p => p._css26);

var _StyledDiv29 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv29",
  componentId: "sc-16syhiy-47"
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 5
});

var _StyledDiv30 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv30",
  componentId: "sc-16syhiy-48"
})({
  marginRight: 5
});

var _StyledSpan12 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan12",
  componentId: "sc-16syhiy-49"
})(["", ""], p => p._css27);

var _StyledSpan13 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan13",
  componentId: "sc-16syhiy-50"
})(p => ({
  fontWeight: "bold",
  fontSize: "14px",
  paddingRight: p._css28
}));

var _StyledSpan14 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan14",
  componentId: "sc-16syhiy-51"
})({
  fontWeight: "bold",
  fontSize: "14px"
});

var _StyledSpan15 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan15",
  componentId: "sc-16syhiy-52"
})(p => ({
  fontSize: 12,
  paddingRight: p._css29
}));

var _StyledDiv31 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv31",
  componentId: "sc-16syhiy-53"
})({
  fontSize: 12,
  textAlign: "center",
  paddingTop: 5,
  marginBottom: "-17px"
});

var _StyledDiv32 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv32",
  componentId: "sc-16syhiy-54"
})({
  display: "flex",
  justifyContent: "center"
});

var _StyledImg2 = _styled("img").withConfig({
  displayName: "event_page___StyledImg2",
  componentId: "sc-16syhiy-55"
})({
  width: "90%",
  padding: "10px 0",
  objectFit: "cover",
  maxHeight: 250,
  maxWidth: 250,
  display: "block",
  margin: "20 auto 20 auto",
  "@media (max-width: 760px)": {
    // Full width in mobile view
    width: "100%"
  }
});

var _StyledDiv33 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv33",
  componentId: "sc-16syhiy-56"
})({
  marginTop: 10,
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
});

var _StyledA = _styled("a").withConfig({
  displayName: "event_page___StyledA",
  componentId: "sc-16syhiy-57"
})({
  textDecoration: "none"
});

var _StyledButton = _styled("button").withConfig({
  displayName: "event_page___StyledButton",
  componentId: "sc-16syhiy-58"
})(["", ""], p => p._css30);

var _StyledP7 = _styled("p").withConfig({
  displayName: "event_page___StyledP7",
  componentId: "sc-16syhiy-59"
})({
  textAlign: "center"
});

var _StyledButton2 = _styled("button").withConfig({
  displayName: "event_page___StyledButton2",
  componentId: "sc-16syhiy-60"
})(["", ""], p => p._css31);

var _StyledDiv34 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv34",
  componentId: "sc-16syhiy-61"
})({
  margin: "0 auto",
  textAlign: "center"
});

var _StyledDiv35 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv35",
  componentId: "sc-16syhiy-62"
})({
  margin: "0 auto"
});

var _StyledP8 = _styled("p").withConfig({
  displayName: "event_page___StyledP8",
  componentId: "sc-16syhiy-63"
})({
  textAlign: "center"
});

var _StyledDiv36 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv36",
  componentId: "sc-16syhiy-64"
})({
  margin: "0 auto"
});

var _StyledP9 = _styled("p").withConfig({
  displayName: "event_page___StyledP9",
  componentId: "sc-16syhiy-65"
})({
  textAlign: "center"
});

var _StyledP10 = _styled("p").withConfig({
  displayName: "event_page___StyledP10",
  componentId: "sc-16syhiy-66"
})({
  textAlign: "center"
});

var _StyledDiv37 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv37",
  componentId: "sc-16syhiy-67"
})({
  display: "flex",
  justifyContent: "center",
  margin: "10px 0 30px 0"
});

var _StyledButton3 = _styled("button").withConfig({
  displayName: "event_page___StyledButton3",
  componentId: "sc-16syhiy-68"
})(["", ""], p => p._css32);

var _StyledDiv38 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv38",
  componentId: "sc-16syhiy-69"
})({
  margin: "0 auto"
});

var _StyledP11 = _styled("p").withConfig({
  displayName: "event_page___StyledP11",
  componentId: "sc-16syhiy-70"
})(["", ""], p => p._css33);

var _StyledP12 = _styled("p").withConfig({
  displayName: "event_page___StyledP12",
  componentId: "sc-16syhiy-71"
})(["", ""], p => p._css34);

var _StyledDiv39 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv39",
  componentId: "sc-16syhiy-72"
})({
  display: "flex",
  justifyContent: "center",
  margin: "10px 0 30px 0"
});

var _StyledButton4 = _styled("button").withConfig({
  displayName: "event_page___StyledButton4",
  componentId: "sc-16syhiy-73"
})(["", ""], p => p._css35);

var _StyledButton5 = _styled("button").withConfig({
  displayName: "event_page___StyledButton5",
  componentId: "sc-16syhiy-74"
})(["", ""], p => p._css36);

var _StyledP13 = _styled("p").withConfig({
  displayName: "event_page___StyledP13",
  componentId: "sc-16syhiy-75"
})({
  color: "red",
  textAlign: "center"
});

var _StyledP14 = _styled("p").withConfig({
  displayName: "event_page___StyledP14",
  componentId: "sc-16syhiy-76"
})({
  color: "red",
  textAlign: "center"
});

var _StyledDiv40 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv40",
  componentId: "sc-16syhiy-77"
})({
  backgroundColor: "#F9F9FB",
  textAlign: "center",
  padding: "20px 10px",
  display: "flex",
  flexDirection: "column",
  color: "#63696d",
  fontSize: 14
});

var _StyledSpan16 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan16",
  componentId: "sc-16syhiy-78"
})({
  marginBottom: 5,
  fontWeight: "bold"
});

var _StyledSpan17 = _styled("span").withConfig({
  displayName: "event_page___StyledSpan17",
  componentId: "sc-16syhiy-79"
})({
  lineHeight: 1.4,
  textDecoration: "none"
});

var _StyledA2 = _styled("a").withConfig({
  displayName: "event_page___StyledA2",
  componentId: "sc-16syhiy-80"
})({
  color: "#63696d !important",
  textDecoration: "none !important"
});

var _StyledDiv41 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv41",
  componentId: "sc-16syhiy-81"
})({
  display: "flex",
  justifyContent: "center",
  marginTop: "100px"
});

var _StyledDiv42 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv42",
  componentId: "sc-16syhiy-82"
})(p => ({
  width: "100%",
  justifyContent: "center",
  position: "fixed",
  bottom: 0,
  left: 0,
  display: p._css37
}));

var _StyledButton6 = _styled("button").withConfig({
  displayName: "event_page___StyledButton6",
  componentId: "sc-16syhiy-83"
})(["", ""], p => p._css38);

export function EventPage({
  theme,
  whitelabel
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    url
  } = useRouteMatch();
  const location = useLocation();
  const {
    eventSlug
  } = useParams();
  const showCheckout = Boolean(useRouteMatch({
    path: `/${language}/e/:eventSlug/checkout/`
  }));
  const showWaitingListForm = Boolean(useRouteMatch({
    path: `/${language}/e/:eventSlug/waiting-list/`
  }));
  const showSeats = Boolean(useRouteMatch({
    path: `/${language}/e/:eventSlug/seats/`
  }));
  const {
    back_arrow_pathname
  } = getSearchParams();
  const {
    isIframe,
    isSimpleIframe,
    isDetailIframe,
    isCheckoutModal
  } = useIframeTypes(whitelabel);
  const checkoutDialogOpen = showCheckout || showSeats;
  const checkoutWasShown = React.useRef();
  const isExtrasEvent = urlParams.has("extras_flow"); // Hide Zendesk chat widget when modal is openend

  React.useEffect(function () {
    const zendeskChatWidget = document.querySelector('[title="Button to launch messaging window"]');
    const zendeskChatWidgetMessage = document.querySelector('[title="Message from company"]');

    if (zendeskChatWidget) {
      zendeskChatWidget.style.display = checkoutDialogOpen ? "none" : "block";
    }

    if (zendeskChatWidgetMessage) {
      zendeskChatWidgetMessage.style.display = checkoutDialogOpen ? "none" : "block";
    }
  }, [checkoutDialogOpen]);
  const {
    trigger: getEventDetails,
    lastResult: event,
    lastError: eventError
  } = useAsyncStatus(async function getEventDetails() {
    const req = await fetch([API_HOST, "events/title", eventSlug].join("/") + "/" + `${isExtrasEvent ? "?checkout_flow=extras" : ""}`, {
      headers: makeTbRequestHeaders(language)
    });
    const res = await req.json();

    if (req.ok) {
      return res;
    } else {
      throw Error();
    }
  });
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1000);
  const registerButtonRef = React.useRef(null);
  const [showStickyButton, setShowStickyButton] = React.useState(false);
  React.useEffect(() => {
    function handleScrollEvent() {
      if (registerButtonRef.current) {
        setShowStickyButton(!isInViewport(registerButtonRef.current, registerButtonRef.current.offsetHeight));
      } else {
        setShowStickyButton(false);
      }
    }

    if (isMobile) {
      // Check if we should initially show the sticky button when the component is first rendered (ie. before a scroll event)
      setShowStickyButton(registerButtonRef.current ? !isInViewport(registerButtonRef.current, registerButtonRef.current.offsetHeight) : false); // show sticky button on page scroll

      window.addEventListener("scroll", handleScrollEvent);
    }

    return () => window.removeEventListener("scroll", handleScrollEvent);
  }, [isMobile, registerButtonRef]); // Mobile view condition when screen size under 1000

  React.useEffect(() => {
    function setWindowSize() {
      if (window.innerWidth <= 1000 !== isMobile) setIsMobile(window.innerWidth <= 1000);
    }

    window.addEventListener("resize", setWindowSize);
    return () => window.removeEventListener("resize", setWindowSize);
  }, [isMobile]);
  React.useEffect(function () {
    getEventDetails();
  }, [getEventDetails]);
  const discountCodeRef = React.useRef(null);
  const {
    status: EXISTING_RESERVATION_STATUS,
    lastResult: existingReservation,
    reset: resetExistingPurchase
  } = useExistingReservationInParam(); // If this is a new visitor, they can make a new reservation

  const {
    trigger: reserveTickets,
    status: NEW_RESERVATION_STATUS,
    lastResult: newReservation,
    lastError: reservationError,
    reset: resetReservation
  } = useAsyncStatus(async function reserveTickets(eventUUID, values) {
    //If existing purchase state is in WAITINGLIST, include uuid to update the same purchase.
    const req = await fetch([API_HOST, "events", eventUUID, existingReservation && existingReservation.purchase.state === "WAITINGLIST" && `purchases/${existingReservation.purchase.uuid}`, "create-order/"].filter(Boolean).join("/") + ( // Tell the backend this is the extras flow. Used to
    // allow purchasing extras without tickets
    isExtrasEvent ? "?checkout_flow=extras" : ""), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify(values)
    });
    const res = await req.json();

    if (req.ok) {
      // Send 'AddToCart' event to Facebook if enabled
      // @ts-ignore: Get global Facebook variable
      const fbq = window.fbq;

      if (fbq) {
        fbq("track", "AddToCart", {}, {
          eventID: res.purchase.uuid
        });
      } // Attach address properties that are in the URL query


      const params = getSearchParams(); // Add email params as email_2 also

      if (params.email) {
        params.email_2 = params.email;
      }

      res.purchase.address = params;
      return res;
    } else {
      throw res;
    }
  }, [event, location.search], 2000);
  useScrollToError(Boolean(reservationError));
  const initialReservation = newReservation || existingReservation;
  const [checkoutContext, setCheckoutContext] = React.useState({
    // Seperate from checkoutComplete because sometimes we need to navigate away to a payment gateway
    warnBeforeExit: true,
    checkoutComplete: false
  });
  React.useEffect(function () {
    // Reset checkout status on clear
    if (checkoutContext.checkoutComplete && !initialReservation) {
      setCheckoutContext(s => ({ ...s,
        warnBeforeExit: true,
        checkoutComplete: false
      }));
    }
  }, [checkoutContext.checkoutComplete, initialReservation]); // When we have a NEW reservation, show the checkout modal
  // We do this here because we need to update the reservation
  // state first, before opening the checkout modal so it can
  // be used by the checkout

  React.useEffect(function () {
    if (newReservation) {
      const pathname = [`/${language}/e/${event?.title_url}/checkout`, newReservation.purchase.has_active_extras_types && !isExtrasEvent && "extras-types", makeSearchParamString(["purchase_uuid", newReservation.purchase.uuid], ["discount_code", discountCodeRef.current || urlParams.get("discount_code")])].filter(Boolean).join("/"); // For simple iframes, request the external modal to open

      if ((isSimpleIframe || isDetailIframe) && !isCheckoutModal) {
        parent.postMessage({
          type: "TICKETBUTLER_CHECKOUT_MODAL",
          open: true,
          url: window.location.origin + pathname
        }, "*");
      } else {
        history.push(pathname);
      }
    }
  }, [history, newReservation, language, isSimpleIframe, event, isCheckoutModal, isExtrasEvent, isDetailIframe]); // Handle continuing the seating flow

  const {
    trigger: createSeatingHoldToken,
    status: CREATE_SEATING_HOLD_TOKEN_STATUS,
    lastResult: seatingHoldToken,
    reset: clearSeatingHoldToken
  } = useAsyncStatus(async function createSeatingHoldToken() {
    // Create hold_token at seatsio before continuing to the seating map
    const req = await fetch([API_HOST, "create-hold-token/"].join("/"));

    if (req.ok) {
      const holdToken = await req.json();
      return holdToken;
    } else {
      // Try again
      window.alert(t("event.requestErrorTryAgain"));
    }
  }, [eventSlug], 2000);
  React.useEffect(() => {
    if (!seatingHoldToken && showSeats) {
      createSeatingHoldToken();
    }
  }, [seatingHoldToken, showSeats, createSeatingHoldToken]); // We can't rely on the URL being correct if a user comes back to the app
  // with an existing purchase.
  // Therefore we need to ensure they are taken to the correct route to
  // continue their purchase.
  // NOTE: ABANDONED/EXPIRED/COMPLETED orders are handled above when the request
  // is made, as the API returns an error response.

  React.useEffect(function () {
    async function goToCheckoutStep() {
      if (existingReservation) {
        switch (existingReservation.purchase.state) {
          case "NEW":
            // Reservation has been made with no significant progress,
            // just continue on the same URL
            break;

          case "PAYGATEWAY":
            // The user has come back from the payment gateway but we're not
            // certain they have completed payment successfully. They could
            // have press the "Back" button or all sorts of things. We provide
            // payment gateways with redirect URLs so let's rely on that
            break;

          case "PAID":
          case "WAITING":
            // The purchase has been paid OR we are just waiting for it to be
            // confirmed. We can show the success page.
            history.push([url, CHECKOUT_ROUTE, "success", makeSearchParamString(["purchase_uuid", existingReservation.purchase.uuid])].filter(Boolean).join("/"));
            break;

          default:
            // We can't be sure what's happening here, let's go back to the Event
            // Page
            if (eventSlug) {
              history.push([`/${language}/e`, eventSlug, makeSearchParamString(["purchase_uuid", undefined])].filter(Boolean).join("/"));
            }

        }
      }
    }

    if (existingReservation && // TODO: Make this more robust
    !INITIAL_PATHNAME.includes("cancelled") && !INITIAL_PATHNAME.includes("success")) {
      goToCheckoutStep();
    }
  }, [eventSlug, existingReservation, history, language, url]);
  /* When the checkout modal is closed;
    1. Reset relevant purchase states
    2. Tell the backend to cancel the order (if it was not completed)
    3. Close the checkout modal iframe (when the detailed iframe is used)
    ...so that the user can checkout again if they want to.
  */

  React.useEffect(function () {
    if (showCheckout) {
      checkoutWasShown.current = true;
    } else if (!showCheckout && checkoutWasShown.current) {
      resetReservation && resetReservation();
      resetExistingPurchase && resetExistingPurchase();

      const exitCheckoutModal = async () => {
        try {
          // Eagerly cancel the order and don't wait for it to finish such not
          // to inturpt the user.
          // LATER: We could wait for this and show a spinner?
          if (!checkoutContext.checkoutComplete && initialReservation && initialReservation.purchase.uuid) {
            await cancelOrder(initialReservation.purchase.uuid, language);
          }
        } catch (e) {
          console.error("Cancelling the purchase failed: ", e);
        }

        checkoutWasShown.current = false; // If we are in detailed iframe mode, and we have come from an event list
        // or calendar, closing the modal should send a message to the host page
        // to close the pop-over modal

        if (isIframe) {
          parent.postMessage({
            type: "TICKETBUTLER_CHECKOUT_MODAL",
            open: false
          }, "*");
          return;
        }
      };

      exitCheckoutModal();
    }
  }, [showCheckout, language, resetReservation, resetExistingPurchase, initialReservation, isIframe, checkoutContext.checkoutComplete]);

  function renderEventDateAndLocation(event) {
    const {
      street,
      venue,
      postcode,
      city,
      country
    } = event.address;
    const addressDetails = [street, venue, postcode, city, country].some(Boolean);
    const itemStyle = {
      margin: "2.5px 0",
      fontSize: 14
    }; // If all ticket types have start dates, don't show the event
    // start date

    const eventDateDisplay = !event.ticket_types.every(ticket => ticket.start_date) && (event.end_date ? //new time format
    formatDateTimeRange(makeDate(event.start_date, true), makeDate(event.end_date, true), {
      dateLocale: language === "da" ? "da-DK" : undefined,
      shortForm: isMobile,
      longForm: true
    }) + " (" + event.timezone + ")" : formatDate(makeDate(event.start_date, true), language === "da" ? "da-DK" : undefined) + " (" + event.timezone + ")"); // If any ticket type has a start date, show a message

    const multipleStartDateMessage = event.ticket_types.some(ticket => ticket.start_date) && /*#__PURE__*/React.createElement(_StyledSpan, {
      _css: [itemStyle, {
        fontStyle: "italic"
      }]
    }, t("event.multipleStartTimes"), ".");
    return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement("h1", null, event.title), eventDateDisplay && event.event_type !== "GIFT_CARD" && /*#__PURE__*/React.createElement(_StyledDiv2, null, /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement("img", {
      src: calendarIcon,
      alt: ""
    })), /*#__PURE__*/React.createElement(_StyledDiv4, null, /*#__PURE__*/React.createElement(_StyledSpan2, {
      _css2: [itemStyle, {
        lineHeight: 1.3,
        marginRight: "10px"
      }]
    }, eventDateDisplay), multipleStartDateMessage)), addressDetails && /*#__PURE__*/React.createElement(_StyledDiv5, null, /*#__PURE__*/React.createElement(_StyledDiv6, null, /*#__PURE__*/React.createElement("img", {
      src: locationIcon,
      alt: ""
    })), /*#__PURE__*/React.createElement(_StyledDiv7, null, venue && /*#__PURE__*/React.createElement(_StyledSpan3, {
      _css3: itemStyle
    }, venue), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledSpan4, {
      _css4: itemStyle
    }, street), street && (postcode || city || country) && ", ", /*#__PURE__*/React.createElement(_StyledSpan5, {
      _css5: itemStyle
    }, postcode, " ", city), /*#__PURE__*/React.createElement(_StyledSpan6, {
      _css6: itemStyle
    }, " ", country)))), Boolean(event.sales_start_on) && // Don't show for simple iframe
    !isSimpleIframe && /*#__PURE__*/React.createElement(_StyledDiv8, null, /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.ticketSalesNotStarted"))));
  }

  if (!event || !whitelabel || !theme || // We are checking if a purchase exists for the purchaseUUID in the query param
  EXISTING_RESERVATION_STATUS === AsyncStates.Pending) {
    return /*#__PURE__*/React.createElement(_StyledDiv9, {
      _css7: [{
        width: "100%",
        maxWidth: MAX_CONTENT_WIDTH,
        margin: "0 auto",
        minHeight: "55vh"
      }, isCheckoutModal && {
        backgroundColor: "white"
      }]
    }, eventError ? /*#__PURE__*/React.createElement(_StyledP, null, t("event.eventNotFound"), ".") : /*#__PURE__*/React.createElement(ContentLoader, null, /*#__PURE__*/React.createElement("rect", {
      x: "22%",
      y: "5",
      width: "100",
      height: "90"
    }), Array.from({
      length: 5
    }).map(function (_, index) {
      return /*#__PURE__*/React.createElement("rect", {
        key: index,
        x: "50%",
        y: 10 + index * 10,
        rx: "2",
        ry: "2",
        width: "28%",
        height: "2"
      });
    })));
  } else {
    const DEFAULT_MAX_TICKETS_PER_TYPE = Math.min(...[event.eventsettings.ticket_limit, // We consider the order limit here but only per-ticket. Proper validation
    // is done on the backend.
    event.eventsettings.order_ticket_limit > 0 ? event.eventsettings.order_ticket_limit : Infinity].filter(Boolean));

    const getMaxTickets = () => {
      let maxAvailiableTickets = 0;
      event.ticket_types.forEach(ticketType => {
        maxAvailiableTickets += ticketType.amount_left;
      });
      return maxAvailiableTickets;
    };

    const maxAvailiableTickets = getMaxTickets();
    const plainTextEventDescription = event.description.replace(/<\/?[^>]+(>|$)/g, "");
    const ticketsSalesClosed = event.ticket_types.every(ticket_type => {
      if (ticket_type.sales_end_date === null) return false;
      if (new Date(ticket_type.sales_end_date) < new Date()) return true;
    });
    const ticketsAreNotActive = event.ticket_types.every(ticket_type => ticket_type.active === false);
    const customButtonText = //@ts-ignore: Allow unsafe key access
    event.eventsettings[`buy_tickets_button_text_${language}`];
    const customButtonLink = event.eventsettings.buy_tickets_button_link;
    const eventImage = event.images[0];
    return /*#__PURE__*/React.createElement(_StyledDiv10, {
      _css8: [{
        minHeight: "55vh"
      }, // Overlay background
      isCheckoutModal && {
        minHeight: "100vh",
        backgroundColor: "hsla(0, 0%, 0%, 0.33)"
      }]
    }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("html", {
      lang: language
    }), /*#__PURE__*/React.createElement("title", null, event.title, " | ", whitelabel.name), whitelabel.favicon ? /*#__PURE__*/React.createElement("link", {
      rel: "icon",
      href: whitelabel.favicon,
      type: "image/*"
    }) : /*#__PURE__*/React.createElement("link", {
      rel: "icon",
      href: ticketbutlerFavicon,
      type: "image/*"
    }), /*#__PURE__*/React.createElement("meta", {
      property: "og:title",
      content: [event.title, whitelabel.name].join(" | ")
    }), event.description && /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: plainTextEventDescription
    }), event.description && /*#__PURE__*/React.createElement("meta", {
      property: "og:description",
      content: plainTextEventDescription
    }), eventImage && /*#__PURE__*/React.createElement("meta", {
      property: "og:image",
      content: eventImage.image
    }), eventImage && /*#__PURE__*/React.createElement("meta", {
      property: "og:image:type",
      content: "image/jpeg"
    }), eventImage && /*#__PURE__*/React.createElement("meta", {
      property: "og:image:width",
      content: "400"
    }), eventImage && /*#__PURE__*/React.createElement("meta", {
      property: "og:image:height",
      content: "300"
    })), /*#__PURE__*/React.createElement(_StyledDiv11, {
      _css9: [{
        maxWidth: MAX_CONTENT_WIDTH,
        width: "100%",
        margin: "0 auto",
        padding: "0 30px",
        "@media(max-width: 320px)": {
          padding: 0
        }
      }, whitelabel.slug === "flyingsuperkids" && {
        backgroundColor: "white",
        borderRadius: 5
      }, isCheckoutModal && {
        backgroundColor: "white"
      }]
    }, isDetailIframe && isCheckoutModal && /*#__PURE__*/React.createElement(_StyledDiv12, null, /*#__PURE__*/React.createElement(BackArrow, {
      theme: theme,
      onClick: function () {
        parent.postMessage({
          type: "TICKETBUTLER_CHECKOUT_MODAL",
          open: false
        }, "*");
      }
    }), /*#__PURE__*/React.createElement("div", {
      onClick: function () {
        parent.postMessage({
          type: "TICKETBUTLER_CHECKOUT_MODAL",
          open: false
        }, "*");
      }
    }, /*#__PURE__*/React.createElement(VisuallyHidden, null, "Close"), /*#__PURE__*/React.createElement(_StyledSpan7, {
      "aria-hidden": true
    }, "\xD7"))), event.is_expired ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 40,
        textAlign: "center"
      }
    }, t("event.expiredEvent")) : event.is_deleted ? /*#__PURE__*/React.createElement("div", {
      style: {
        height: "calc(100vh - 100px)",
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        margin: "auto",
        textAlign: "center"
      }
    }, /*#__PURE__*/React.createElement("span", null, t("event.canceledEvent")))) : event.ticket_types.length === 0 ? /*#__PURE__*/React.createElement("div", {
      style: {
        height: "calc(100vh - 100px)",
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        margin: "auto",
        textAlign: "center"
      }
    }, /*#__PURE__*/React.createElement("span", null, t("event.noTicketsAdded")))) : /*#__PURE__*/React.createElement(_StyledDiv13, {
      _css10: isSimpleIframe ? // Some buffer for iframes so the box-shadow doesn't get cut off
      "95%" : "100%",
      _css11: MAX_CONTENT_WIDTH,
      _css12: isSimpleIframe || !eventImage && !event.description ? "center" : "space-between"
    }, // Back button for users who came from an event list
    !checkoutDialogOpen && !isCheckoutModal && back_arrow_pathname && /*#__PURE__*/React.createElement(_StyledDiv14, null, /*#__PURE__*/React.createElement(BackArrow, {
      theme: theme,
      onClick: function () {
        history.push(back_arrow_pathname + makeSearchParamString(["back_arrow_pathname", undefined]));
      }
    })), // Hide event details (date/time, location,
    // image and description for iframes and quick checkout
    !isSimpleIframe && (event.images.length > 0 || event.description || isMobile) && /*#__PURE__*/React.createElement(_StyledDiv15, null, eventImage && eventImage.medium && /*#__PURE__*/React.createElement(_StyledImg, {
      src: eventImage.medium,
      alt: event.title
    }), isMobile && renderEventDateAndLocation(event), event.description.length > 0 && /*#__PURE__*/React.createElement(_StyledDiv16, {
      _css13: "1px solid " + theme.colour_primary
    }, /*#__PURE__*/React.createElement(_StyledDiv17, {
      dangerouslySetInnerHTML: {
        __html: event.description.replace("iframe", "iframe allowfullscreen='true'")
      },
      _css14: eventImage ? "30px auto" : "0 auto"
    }))), /*#__PURE__*/React.createElement(_StyledForm, {
      onChange: resetReservation,
      onSubmit: function (e) {
        e.preventDefault();
        const values = serialize(e.target, {
          hash: true,
          empty: true
        });
        reserveTickets(event.uuid, values);

        if (whitelabel?.tiktok_pixel_id) {
          window.ttq.track("ViewContent");
        }
      },
      _css15: isDetailIframe && (event.description || event.images.length > 0) ? 410 : 570
    }, isSimpleIframe && /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: "right"
      }
    }, /*#__PURE__*/React.createElement(LanguageSelector, {
      current: language,
      onSelect: newLanguage => {
        const newUrl = location.pathname.replace(`/${language}/`, `/${newLanguage}/`);
        history.push(newUrl + makeSearchParamString());
      }
    })), /*#__PURE__*/React.createElement(_StyledDiv18, null, (event.event_type === "GIFT_CARD" && isSimpleIframe || !isMobile) && renderEventDateAndLocation(event), !event.is_sold_out && event.has_seating && whitelabel.hide_ticket_types_and_prices && event.show_few_tickets_left_tag && event.eventsettings.show_tickets_left && event.eventsettings.show_tag_few_tickets_left && /*#__PURE__*/React.createElement(_StyledDiv19, null, /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.fewTicketsLeft"))), /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: 15
      }
    }, !isExtrasEvent && event.ticket_types.filter(({
      is_on_sale
    }) => is_on_sale).sort((a, b) => {
      return a.sort_id - b.sort_id;
    }).map(function renderTicketType(ticket_type, i) {
      const amountLimits = [ticket_type.amount_left, DEFAULT_MAX_TICKETS_PER_TYPE];

      if (event.eventsettings.event_ticket_limit_amount_left) {
        amountLimits.push(event.eventsettings.event_ticket_limit_amount_left);
      }

      if (ticket_type.is_members_only) {
        amountLimits.push(event.eventsettings.ticket_limit_members_only);
      }

      const amountAvailable = Math.min(...amountLimits);
      const soldOut = ticket_type.sold_out || event.eventsettings.event_ticket_limit_sold_out || amountAvailable < 1; // ticket type is expired if ticket type has start date - 12 hours from now

      const now = new Date(Date.now());
      const expired = ticket_type.start_date && new Date(ticket_type.start_date).getTime() < now.setHours(now.getHours() - 12);
      let price = ticket_type.price;
      let ticketFee = ticket_type.fee;

      if (!event.eventsettings.show_price_with_vat) {
        // Remove the tax rate from the price and ticket fee
        price = price / (1 + whitelabel.vat / 100);
        ticketFee = ticketFee / (1 + whitelabel.vat / 100);
      }

      const ticketAmountSelector = () => {
        switch (true) {
          case soldOut:
            return /*#__PURE__*/React.createElement("span", null, t("event.soldOut"));

          case expired:
            return /*#__PURE__*/React.createElement("span", null, t("event.expired"));

          default:
            {
              const isOnlyOneTicketTypeForSale = event.ticket_types.filter(({
                active
              }) => active).length === 1;
              const options = ticket_type.constraint_definition ? ticket_type.constraint_definition.reduce((acc, n) => {
                if (n <= amountAvailable) {
                  return acc.concat({
                    label: n,
                    value: n
                  });
                } else return acc;
              }, []) : Array.from({
                length: amountAvailable + 1
              }).map((_, i) => {
                return {
                  label: i,
                  value: i
                };
              });
              return /*#__PURE__*/React.createElement(Select, {
                "data-testid": "select-ticket",
                name: String(ticket_type.pk),
                styles: {
                  container: styles => ({ ...styles,
                    minWidth: 70
                  })
                },
                isSearchable: false,
                defaultValue: isOnlyOneTicketTypeForSale ? options[1] : options[0],
                options: options
              });
            }
        }
      };

      return !expired && (!event?.has_seating || !whitelabel.hide_ticket_types_and_prices) && /*#__PURE__*/React.createElement(_StyledDiv20, null, /*#__PURE__*/React.createElement(_StyledDiv21, null, /*#__PURE__*/React.createElement(_StyledP2, {
        _css16: [eventDetailHeading, {
          "@media (max-width: 500px)": {
            wordWrap: "break-word"
          }
        }]
      }, ticket_type.title), ticket_type.description && /*#__PURE__*/React.createElement(_StyledP3, {
        _css17: [styles.caption, {
          paddingRight: 30,
          "@media (max-width: 500px)": {
            paddingRight: 0
          }
        }]
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: ticket_type.description
        }
      })), ticket_type.start_date && /*#__PURE__*/React.createElement(_StyledP4, {
        _css18: styles.caption
      }, formatDate(makeDate(ticket_type.start_date, true), language === "en" ? "en-GB" : "da-DK")), !event.is_sold_out && event.eventsettings.show_tickets_left && event.eventsettings.show_tag_few_tickets_left && ticket_type.show_few_tickets_left_tag && /*#__PURE__*/React.createElement(_StyledDiv22, null, /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.fewTicketsLeft")))), /*#__PURE__*/React.createElement(_StyledDiv23, {
        _css19: event?.has_seating ? "column" : "row",
        _css20: event?.has_seating ? "end" : "center"
      }, /*#__PURE__*/React.createElement(_StyledDiv24, {
        _css21: event?.has_seating ? 0 : 5
      }, ticket_type.is_temporarily_sold_out ? /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.temporarilySoldOut")) : event.eventsettings.is_no_show_fee && !ticket_type.is_free ? /*#__PURE__*/React.createElement(_StyledSpan8, {
        _css22: styles.caption
      }, /*#__PURE__*/React.createElement("strong", null, t("event.free")), t("event.noShowFee", {
        price: whitelabel.numberFormat(price)
      }), "*") : ticket_type.is_free ? /*#__PURE__*/React.createElement(_StyledSpan9, {
        _css23: event?.has_seating ? 0 : 10
      }, whitelabel.overwrite_free_text ? whitelabel.overwrite_free_text : t("event.free")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledSpan10, null, whitelabel.numberFormat(price)), /*#__PURE__*/React.createElement(_StyledSpan11, {
        _css24: event?.has_seating ? 0 : 10
      }, !ticket_type.is_free && !event.eventsettings.organizer_absorb_fees && " + " + whitelabel.numberFormat(ticketFee) + " " + t("event.fee")))), /*#__PURE__*/React.createElement("div", null, !event.has_seating && !ticket_type.is_temporarily_sold_out && ticketAmountSelector(), !event.is_sold_out && event.eventsettings.show_tickets_left && event.eventsettings.show_exact_tickets_left_count && !ticket_type.sold_out && ticket_type.show_exact_tickets_left_count && /*#__PURE__*/React.createElement(_StyledDiv25, null, event.eventsettings.event_ticket_limit_amount_left ? event.eventsettings.event_ticket_limit_amount_left < ticket_type.amount_left ? event.eventsettings.event_ticket_limit_amount_left : ticket_type.amount_left : ticket_type.amount_left, " ", t("event.left")))));
    }), isExtrasEvent && event && event.extras_types.length > 0 && event.extras_types.filter(({
      is_on_sale
    }) => is_on_sale).sort((a, b) => {
      return a.sort_id - b.sort_id;
    }).map(function renderExtrasType(extras_type, i) {
      const amountLimits = [extras_type.amount_left, extras_type.limit];

      if (event.eventsettings.event_ticket_limit_amount_left) {
        amountLimits.push(event.eventsettings.event_ticket_limit_amount_left);
      }

      if (extras_type.is_members_only) {
        amountLimits.push(event.eventsettings.ticket_limit_members_only);
      }

      const amountAvailable = Math.min(...amountLimits);
      const soldOut = extras_type.sold_out || amountAvailable < 1; // ticket type is expired if ticket type has start date - 12 hours from now

      let price = extras_type.price;
      let extrasFee = extras_type.fee;

      if (!event.eventsettings.show_price_with_vat) {
        // Remove the tax rate from the price
        price = price / (1 + whitelabel.vat / 100);
        extrasFee = extrasFee / (1 + whitelabel.vat / 100);
      }

      const extrasAmountSelector = () => {
        switch (true) {
          case soldOut:
            return /*#__PURE__*/React.createElement("span", null, t("event.soldOut"));

          default:
            {
              const isOnlyOneTicketTypeForSale = event.extras_types.filter(({
                active
              }) => active).length === 1;
              const options = extras_type.constraint_definition ? extras_type.constraint_definition.reduce((acc, n) => {
                if (n <= amountAvailable) {
                  return acc.concat({
                    label: n,
                    value: n
                  });
                } else return acc;
              }, []) : Array.from({
                length: amountAvailable + 1
              }).map((_, i) => {
                return {
                  label: i,
                  value: i
                };
              });
              return /*#__PURE__*/React.createElement(Select, {
                "data-testid": "select-extras",
                name: String(extras_type.pk),
                styles: {
                  container: styles => ({ ...styles,
                    minWidth: 70
                  })
                },
                isSearchable: false,
                defaultValue: isOnlyOneTicketTypeForSale ? options[1] : options[0],
                options: options
              });
            }
        }
      };

      return /*#__PURE__*/React.createElement(_StyledDiv26, {
        key: i
      }, /*#__PURE__*/React.createElement(_StyledDiv27, null, /*#__PURE__*/React.createElement(_StyledDiv28, null, /*#__PURE__*/React.createElement(_StyledP5, {
        _css25: [eventDetailHeading, {
          "@media (max-width: 500px)": {
            wordWrap: "break-word"
          }
        }]
      }, extras_type.title), extras_type.description && /*#__PURE__*/React.createElement(_StyledP6, {
        _css26: [styles.caption, {
          paddingRight: 30,
          "@media (max-width: 500px)": {
            paddingRight: 0
          }
        }]
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: extras_type.description
        }
      }))), /*#__PURE__*/React.createElement(_StyledDiv29, null, /*#__PURE__*/React.createElement(_StyledDiv30, null, extras_type.is_temporarily_sold_out ? /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.temporarilySoldOut")) : event.eventsettings.is_no_show_fee && !extras_type.is_free ? /*#__PURE__*/React.createElement(_StyledSpan12, {
        _css27: styles.caption
      }, /*#__PURE__*/React.createElement("strong", null, t("event.free")), t("event.noShowFee", {
        price: whitelabel.numberFormat(price)
      }), "*") : extras_type.is_free ? /*#__PURE__*/React.createElement(_StyledSpan13, {
        _css28: event?.has_seating ? 0 : 10
      }, whitelabel.overwrite_free_text ? whitelabel.overwrite_free_text : t("event.free")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledSpan14, null, whitelabel.numberFormat(price)), /*#__PURE__*/React.createElement(_StyledSpan15, {
        _css29: event?.has_seating ? 0 : 10
      }, !extras_type.is_free && !event.eventsettings.organizer_absorb_fees && " + " + whitelabel.numberFormat(extrasFee) + " " + t("event.fee")))), /*#__PURE__*/React.createElement("div", null, !extras_type.is_temporarily_sold_out && extrasAmountSelector(), !event.is_sold_out && event.eventsettings.show_tickets_left && event.eventsettings.show_exact_tickets_left_count && !extras_type.sold_out && extras_type.show_exact_tickets_left_count && /*#__PURE__*/React.createElement(_StyledDiv31, null, extras_type.amount_left, " ", t("event.left"))))), extras_type.extras_image_url && /*#__PURE__*/React.createElement(_StyledDiv32, null, /*#__PURE__*/React.createElement(_StyledImg2, {
        src: extras_type.extras_image_url
      })));
    })), /*#__PURE__*/React.createElement(_StyledDiv33, null, // If a custom link is provided, always show the button
    customButtonLink ? /*#__PURE__*/React.createElement(_StyledA, {
      href: customButtonLink,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement(_StyledButton, {
      type: "button",
      _css30: getThemedButton(theme)
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: 230,
        height: 57,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement("div", null, customButtonText || t("event.chooseYourSpot"))))) : isExtrasEvent ? event.is_extras_sold_out ? /*#__PURE__*/React.createElement(_StyledP7, null, t("event.soldOut")) : /*#__PURE__*/React.createElement(LoadingButton, {
      loading: NEW_RESERVATION_STATUS === AsyncStates.Pending,
      loadingMessage: t("event.preparingOrder"),
      success: NEW_RESERVATION_STATUS === AsyncStates.Success,
      successMessage: buttonCheckMark
    }, /*#__PURE__*/React.createElement(_StyledButton2, {
      ref: registerButtonRef,
      type: "submit",
      _css31: getThemedButton(theme)
    }, customButtonText || t("event.buyExtras"))) : event.sales_start_on ? /*#__PURE__*/React.createElement(_StyledDiv34, null, /*#__PURE__*/React.createElement("p", null, t("event.ticketSalesStart") + ":"), /*#__PURE__*/React.createElement("p", null, formatDate(makeDate(event.sales_start_on, true), language === "da" ? "da-DK" : undefined))) : event.ticket_types.every(ticket_type => ticket_type.is_temporarily_sold_out) ? /*#__PURE__*/React.createElement(_StyledDiv35, null, /*#__PURE__*/React.createElement(_StyledP8, null, t("event.eventTemporarilySoldOut"), /*#__PURE__*/React.createElement("br", null), t("event.ticketsMightBecomeAvailable"))) : event.is_sold_out ? ticketsAreNotActive || ticketsSalesClosed ? /*#__PURE__*/React.createElement(_StyledDiv36, null, /*#__PURE__*/React.createElement("p", null, t("event.ticketSaleClosed"))) : event.eventsettings.show_waiting_list ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledP9, null, t("event.eventIsSoldOut")), /*#__PURE__*/React.createElement(_StyledP10, null, event.is_free_event ? t("event.notifyAboutAvailableSpots") : t("event.notifyAboutAvailableTickets")), /*#__PURE__*/React.createElement(_StyledDiv37, null, /*#__PURE__*/React.createElement(_StyledButton3, {
      ref: registerButtonRef,
      type: "button",
      onClick: () => {
        history.push([`/${language}/e`, eventSlug, "waiting-list", makeSearchParamString()].filter(Boolean).join("/"));
      },
      _css32: [getThemedButton(theme), {
        height: 60
      }]
    }, t("event.signUpToTicketNotifications")))) : /*#__PURE__*/React.createElement(_StyledDiv38, null, /*#__PURE__*/React.createElement("p", null, t("event.eventIsSoldOut"))) : /*#__PURE__*/React.createElement(React.Fragment, null, event.eventsettings.is_no_show_fee && (!event?.has_seating || !whitelabel.hide_ticket_types_and_prices) ? /*#__PURE__*/React.createElement(_StyledP11, {
      _css33: styles.caption
    }, "*", t("event.applyNoShowFee"), ".") : !event.is_free_event && /*#__PURE__*/React.createElement(_StyledP12, {
      _css34: [styles.caption, {
        alignSelf: "flex-end",
        fontSize: 12,
        fontWeight: event.eventsettings.show_price_with_vat ? "normal" : "bold"
      }]
    }, event.eventsettings.show_price_with_vat ? t("event.priceIncludesVAT", {
      vat: event.eventsettings.vat_exempt ? "0%" : whitelabel.vat + "%"
    }) : t("event.addedVATToTicketPrice", {
      vat: whitelabel.vat + "%"
    })), event.has_seating && !isExtrasEvent ? /*#__PURE__*/React.createElement(_StyledDiv39, null, /*#__PURE__*/React.createElement(LoadingButton, {
      loading: CREATE_SEATING_HOLD_TOKEN_STATUS === AsyncStates.Pending,
      loadingMessage: t("event.preparingOrder"),
      success: CREATE_SEATING_HOLD_TOKEN_STATUS === AsyncStates.Success,
      successMessage: buttonCheckMark
    }, /*#__PURE__*/React.createElement(_StyledButton4, {
      ref: registerButtonRef,
      type: "button",
      onClick: () => {
        const pathname = [`/${language}/e`, event.title_url, "seats", makeSearchParamString()].filter(Boolean).join("/"); // For simple iframes, request the external modal to open

        if (isSimpleIframe) {
          parent.postMessage({
            type: "TICKETBUTLER_CHECKOUT_MODAL",
            open: true,
            url: window.location.origin + pathname
          }, "*");
        } else {
          history.push(pathname);
        }
      },
      _css35: getThemedButton(theme)
    }, customButtonText || t("event.chooseYourSpot")))) : /*#__PURE__*/React.createElement(LoadingButton, {
      loading: NEW_RESERVATION_STATUS === AsyncStates.Pending,
      loadingMessage: t("event.preparingOrder"),
      success: NEW_RESERVATION_STATUS === AsyncStates.Success,
      successMessage: buttonCheckMark
    }, /*#__PURE__*/React.createElement(_StyledButton5, {
      ref: registerButtonRef,
      type: "submit",
      _css36: getThemedButton(theme)
    }, customButtonText || t(event.eventsettings.attach_voucher || event.event_type === "GIFT_CARD" ? "event.buyGiftCards" : event.is_free_event ? "event.continueRegistration" : "event.buyTickets")))), NEW_RESERVATION_STATUS === AsyncStates.Error && (reservationError && !(reservationError instanceof Error) && Array.isArray(reservationError.non_field_errors) ? /*#__PURE__*/React.createElement(_StyledP13, {
      className: "errorMessage"
    }, reservationError.non_field_errors.join(" ")) : /*#__PURE__*/React.createElement(_StyledP14, {
      className: "errorMessage"
    }, t("event.requestErrorTryAgain"))))), !event.is_free_event && !event.eventsettings.invoice_payment_only && /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "15px 0"
      }
    }, /*#__PURE__*/React.createElement(PaymentIcons, {
      whitelabel: whitelabel,
      showMobilePay: event.eventsettings.mobile_pay_active
    })), !isIframe && /*#__PURE__*/React.createElement(_StyledDiv40, null, /*#__PURE__*/React.createElement(_StyledSpan16, null, t("event.contactInformation")), // additional_info is HTML that overrides the default
    // contact information display.
    event.address.additional_info ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: event.address.additional_info
      }
    }) : [event.address.business_name, event.address.email, event.address.phone].filter(detail => detail && detail.length > 0).map((text, i) => /*#__PURE__*/React.createElement(_StyledSpan17, {
      key: i
    }, text === event.address.email ? /*#__PURE__*/React.createElement(_StyledA2, {
      href: "mailto:" + event.address.email,
      target: "_blank",
      rel: "noreferrer"
    }, text) : text))))), /*#__PURE__*/React.createElement(CheckoutContext.Provider, {
      value: { ...checkoutContext,
        setCheckoutContext // Helper to request any reservations in state to be cleared.
        // Usually called when the checkout modal is closed.

      }
    }, /*#__PURE__*/React.createElement(CheckoutDialog, {
      isOpen: checkoutDialogOpen,
      resetToSeating: isShowSeatingMap,
      whitelabel: whitelabel,
      purchaseUUID: initialReservation ? initialReservation.purchase.uuid : undefined,
      onClose: () => {
        if (clearSeatingHoldToken) {
          clearSeatingHoldToken();
        }
      }
    }, // If the user needs to pick seats
    showSeats ? // We can't render the Seating without the seatingHoldToken, so we should wait for it
    seatingHoldToken ? /*#__PURE__*/React.createElement(Seating, {
      theme: theme,
      whitelabel: whitelabel,
      event: event,
      onComplete: function (eventUUID, values, discountCode) {
        if (discountCode) discountCodeRef.current = discountCode; //@ts-ignore : Ignore global Tiktok Pixel variable

        if (whitelabel?.tiktok_pixel_id) {
          window.ttq.track("InitiateCheckout");
        }

        return reserveTickets(eventUUID, values);
      },
      reservationError: reservationError,
      reservationReset: resetReservation,
      seatsHaveTicketTypeOptions: whitelabel.seating_single_category,
      NEW_RESERVATION_STATUS: NEW_RESERVATION_STATUS,
      DEFAULT_MAX_TICKETS_PER_TYPE: DEFAULT_MAX_TICKETS_PER_TYPE,
      maxAvailiableTickets: maxAvailiableTickets,
      holdToken: seatingHoldToken,
      onClose: () => {
        clearSeatingHoldToken();
      }
    }) : /*#__PURE__*/React.createElement(_StyledDiv41, null, /*#__PURE__*/React.createElement(Spinner, {
      color: theme.colour_primary,
      size: 50
    })) : // If the user has reserved tickets, show the checkout flow
    initialReservation ? /*#__PURE__*/React.createElement(Checkout, {
      theme: theme,
      seatsHaveTicketTypeOptions: whitelabel.seating_single_category,
      event: event,
      whitelabel: whitelabel,
      existingReservation: initialReservation
    }) : null)), /*#__PURE__*/React.createElement(RegistrationDialog, {
      isOpen: showWaitingListForm,
      whitelabel: whitelabel,
      onDismiss: function () {
        if (eventSlug) history.push([`/${language}/e`, eventSlug, makeSearchParamString(["purchase_uuid", undefined])].filter(Boolean).join("/"));
      }
    }, /*#__PURE__*/React.createElement(WaitingList, {
      theme: theme,
      event: event
    })), !(isIOS && isIframe) && (isDetailIframe && isMobile || isMobile) && /*#__PURE__*/React.createElement(_StyledDiv42, {
      _css37: showStickyButton ? "flex" : "none"
    }, /*#__PURE__*/React.createElement(_StyledButton6, {
      onClick: () => {
        if (registerButtonRef.current) {
          window.scroll({
            behavior: "smooth",
            top: registerButtonRef.current.offsetTop + registerButtonRef.current.clientHeight - window.innerHeight + 220 // Allow for the contact info

          });
        }
      },
      _css38: getThemedButton(theme)
    }, t(event.eventsettings.attach_voucher || event.event_type === "GIFT_CARD" ? "event.goToGiftCards" : event.is_free_event ? "event.goToRegistration" : "event.goToTickets")))));
  }
}

var _StyledDiv43 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv43",
  componentId: "sc-16syhiy-84"
})(p => ({
  cursor: "pointer",
  border: p._css39,
  backgroundColor: p._css40,
  color: "white",
  borderRadius: 5,
  textAlign: "center",
  width: 60,
  height: 60,
  position: "relative",
  "@media(max-width: 420px)": {
    width: 44,
    height: 44
  }
}));

var _StyledDiv44 = _styled("div").withConfig({
  displayName: "event_page___StyledDiv44",
  componentId: "sc-16syhiy-85"
})({
  position: "absolute",
  top: "50%",
  left: "44%",
  transform: "translate(-50%, -50%) rotate(90deg)",
  "@media(max-width: 420px)": {
    left: "40%"
  }
});

var _StyledImg3 = _styled("img").withConfig({
  displayName: "event_page___StyledImg3",
  componentId: "sc-16syhiy-86"
})({
  "@media(max-width: 420px)": {
    height: 12
  }
});

function BackArrow({
  theme,
  onClick
}) {
  return /*#__PURE__*/React.createElement(_StyledDiv43, {
    onClick: onClick,
    _css39: "1px solid " + theme.colour_primary,
    _css40: theme.colour_primary
  }, /*#__PURE__*/React.createElement(_StyledDiv44, null, /*#__PURE__*/React.createElement(_StyledImg3, {
    src: freeArrow
  })));
}